import { LocationModel } from '@/models/common/location';
import { SettingsModel } from '@/models/group/settings';
import { SensorOrchardModel } from './sensorOrchard';
import { TimeHelper } from '@/helpers/TimeHelper';
import { SensorStatusModel } from './sensorStatus';

class SensorModel {
  id;
  createdOn;
  barcode;
  iccid;
  imei;
  mac;
  location;
  lastStatus;
  orchards;
  sensorName;
  sensorAddedOn;
  sensorRemovedOn;
  groupId;
  currentStatus;
  pestType;
  pestTypeName;
  battery;
  sensorSettings;
  isBiosecurity;
  latestSensorActivityDate;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  get hasStatus() {
    return (
      this.lastStatus !== null && !(Object.keys(this.lastStatus).length === 0 && this.lastStatus.constructor === Object)
    );
  }

  get hasLocation() {
    return this.location.isValid;
  }

  get orchardCount() {
    return this.orchards.length;
  }

  get batteryLevel() {
    return this.hasStatus ? `${this.lastStatus.battery}%` : 'N/A';
  }

  get lastReported() {
    return this.latestSensorActivityDate ? TimeHelper.parse(this.latestSensorActivityDate) : 'N/A';
  }

  get dateDeployed() {
    return this.sensorAddedOn ? TimeHelper.formatDateTime(this.sensorAddedOn) : 'N/A';
  }

  get dateRemoved() {
    return this.sensorRemovedOn ? TimeHelper.formatDateTime(this.sensorRemovedOn) : 'N/A';
  }

  get isSensorBiosecurity() {
    return this.sensorSettings.releaseThresholdNight == null && this.sensorSettings.releaseThresholdDay == null;
  }

  populate(data) {
    this.id = data.id || data.sensorId || null;
    this.lastStatus = data.lastStatus || null;
    this.createdOn = data.createdOn || null;
    this.sensorAddedOn = data.sensorAddedOn || null;
    this.sensorRemovedOn = data.sensorRemovedOn || null;
    this.barcode = data.barcode || '';
    this.iccid = data.iccid || '';
    this.imei = data.imei || '';
    this.mac = data.mac || '';
    this.sensorName = data.sensorName || '';
    this.orchards = this.populateOrchards(data.currentOrchards || []);
    this.location = new LocationModel(data.location || null);
    this.groupId = data.groupId || null;
    this.statuses = data.statuses ? data.statuses.map((status) => new SensorStatusModel(status)).sort((a, b) => {
      return a.createdOn < b.createdOn ? 1 : -1
    }) : []
    this.currentStatus = this.statuses.length > 0 ? this.statuses.filter((s) => s.completedOn == null)[0] : new SensorStatusModel(data.currentStatus);
    this.pestType = data.pestType || null;
    this.pestTypeName = data.pestTypeName || null;

    this.battery = data.battery || null;
    this.sensorSettings = new SettingsModel(data.sensorSettings || null);
    this.isBiosecurity = this.isSensorBiosecurity;
    this.latestSensorActivityDate = data.latestSensorActivityDate
  }

  get formattedBattery() {
    return `${this.battery}%`
  }

  populateOrchards(data) {
    let output = [];
    if (data.length > 0) {
      for (let o in data) {
        output.push(new SensorOrchardModel(data[o]));
      }
    }
    return output;
  }

  toDetailsUpdateJson(originalData) {
    let output = {};

    if (this.sensorSettings !== originalData.sensorSettings) {
      if(this.isBiosecurity === 'true') {
        this.sensorSettings = {};
        this.sensorSettings.autoRelease = 'false';
      }
      else {
        this.sensorSettings = {};
        this.sensorSettings.releaseThresholdDay = '2';
        this.sensorSettings.releaseThresholdNight = '4';
      }
      output.sensorSettings = this.sensorSettings;
    }

    return output;
  }
}

export { SensorModel };
